'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { IngestionBanner } from 'src/app/(main)/_components/ingestion-banner'
import { useUser } from 'src/deprecated/contexts/User'
import { useGetStocklistSourceStatus } from 'src/deprecated/hooks/api/useGetStocklistSourceStatus'

export function IngestionBannerWrapper() {
  const { data: stockListStatus } = useGetStocklistSourceStatus()
  const { isSellerUsingSos, isSellerWithCustomIntegration } = useUser()

  if (!stockListStatus?.hasError) {
    return null
  }

  return (
    <IngestionBanner
      stocklistSourceStatus={stockListStatus}
      isSellerUsingSos={isSellerUsingSos}
      isSellerWithCustomIntegration={isSellerWithCustomIntegration}
    />
  )
}
